import React from 'react';
import usePageTitle from '../hooks/usePageTitle';
import { useLanguage } from '../contexts/LanguageContext';
import GameLayout from './GameLayout';
import GuessAlumni from './GuessAlumni';

const GuessPage = () => {
  const { t } = useLanguage();
  usePageTitle(t('trivia.tabGuess'));

  return (
    <GameLayout title={t('trivia.tabGuess')} emoji="🕵️">
      <GuessAlumni />
    </GameLayout>
  );
};

export default GuessPage;
